import http from "src/services/http";
import * as types from "../types/fidelidade_mapa";
import store from "../index";

export const listarClientesMapa = () => {
  return (dispatch) => {
    dispatch({ type: types.FIDELIDADE_MAPA_LOADING, payload: true });
    http.get("/api/v2/empresa/fidelidade/mapa").then(
      (response) => {
        dispatch([
          { type: types.FIDELIDADE_MAPA_SET_CLIENTES, payload: response.data },
          { type: types.FIDELIDADE_MAPA_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.FIDELIDADE_MAPA_LOADING, payload: false }]);
      }
    );
  };
};

export const carregaLocalizacao = () => {
  return (dispatch) => {
    dispatch({ type: types.FIDELIDADE_MAPA_LOADING, payload: true });
    http.get("/api/v2/empresa/fidelidade/mapa/localizacao").then(
      (response) => {
        dispatch([
          {
            type: types.FIDELIDADE_MAPA_SET_LOCALIZACAO_EMPRESA,
            payload: response.data,
          },
          { type: types.FIDELIDADE_MAPA_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch({ type: types.FIDELIDADE_MAPA_LOADING, payload: false });
      }
    );
  };
};
